import { useState, useContext, useEffect } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import * as Utilities from '../../../Components/Utils/Utils';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import Modal from 'react-bootstrap/Modal';
import GestionLocatario from './GestionLocatario';
import { useQuery } from 'react-query';
import * as KeyNames from '../../../api/KeyNames';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import ConsultarCierreVentas from "./ConsultarCierreVentas";
import AgTable from '../../../Components/Table/AgTable';

function Locatarios({ title }) {

    const animatedComponents = makeAnimated();

    let ueByNotification = window.sessionStorage.getItem("ContratoPorNotificacionUE");
    let unidadEco = null;
    if (ueByNotification) unidadEco = Utilities.getListUnidadesEconomicas().list.find((element => element.value == ueByNotification));

    const [unidadEconomica, setUnidadEconomica] = useState(unidadEco ? unidadEco : Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const tokenn = useGetToken();
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);


    const [abirGuardarContrato, setAbirGuardarContrato] = useState(false);
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    const [getData, setGetData] = useState(null);
    const [listaClasificacionComercial, setListaClasificacionComercial] = useState(null);
    const [listaClasificacionSubComercial, setListaClasificacionSubComercial] = useState(null);
    const [listaCategoria, setListaCategoria] = useState(null);

    const [contratoCurrentEdit, setContratoCurrentEdit] = useState(null);

    const header = [
        {
            headerName: 'Contrato',
            field: 'numContrato',
            type: 'rightAligned',
        },
        {
            headerName: 'RUC',
            field: 'ruc',
            type: 'rightAligned',
        },
        {
            headerName: 'Nombre',
            field: 'nombre'
        },
        {
            headerName: 'Objetos',
            field: 'objetos'
        },
        {
            headerName: 'Administrador',
            hide: true,
            valueGetter: 'data.administrador.name',
        },
        {
            headerName: 'Correo electrónico administrador',
            hide: true,
            valueGetter: 'data.administrador.email',
        },
        {
            headerName: 'Operador',
            hide: true,
            valueGetter: 'data.operador.name',
        },
        {
            headerName: 'Correo electrónico operador',
            hide: true,
            valueGetter: 'data.operador.email',
        },
        {
            headerName: 'Cierre',
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm"
                    onClick={
                        function () {
                            setContratoCurrentEdit(props.data);
                            setViewCierreVentas(true);
                        }
                    } >
                    <i className="fi-rr-interactive"></i>
                </button>
            )
        },
        {
            headerName: 'Gestionar',
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm" onClick={
                    function () {
                        setContratoCurrentEdit(props.data);
                        setAbirGuardarContrato(true);
                    }
                } >
                    <i className="fi-rr-settings"></i>
                </button>
            )
        }
    ]

    function onAfterGuardar(action) {
        setAbirGuardarContrato(false);
        if (action === true) setGuardadoExitoso(true);
    }
    function guardadoExistosoModal() {
        setGuardadoExitoso(false)
        window.location.reload(false);
    }

    let contratoIdByNotification = window.sessionStorage.getItem("ContratoPorNotificacionID");
    if (contratoIdByNotification) {
        function abrirEditarContrato() {
            if (listaClasificacionComercial != null &&
                listaClasificacionSubComercial != null &&
                listaCategoria != null &&
                getData != null) {
                let currentContrato = getData.table.find(
                    element => element.numContrato == contratoIdByNotification
                )
                if (currentContrato) {
                    currentContrato['clasificacionComercial.value'] = currentContrato.clasificacionComercial.value;
                    currentContrato['clasificacionComercial.label'] = currentContrato.clasificacionComercial.label;

                    currentContrato['clasificacionSubComercial.value'] = currentContrato.clasificacionSubComercial.value;
                    currentContrato['clasificacionSubComercial.label'] = currentContrato.clasificacionSubComercial.label;

                    currentContrato['categoria.value'] = currentContrato.categoria.value;
                    currentContrato['categoria.label'] = currentContrato.categoria.label;
                }

                setContratoCurrentEdit(currentContrato);
                setAbirGuardarContrato(true);
                sessionStorage.removeItem('ContratoPorNotificacionUE');
                sessionStorage.removeItem('ContratoPorNotificacionID');
            }

            else setTimeout(() => abrirEditarContrato(), 1000);
        }

        setTimeout(() => abrirEditarContrato(), 1500);

    }

    let { data: dataComercial, isLoading: isLoadingComercial, isError: isErrorComercial, error } = useQuery([KeyNames.SessionRespuesta, {
        token: tokenn, type: 'comer'
    }],
        async () => await Api.ClasificacionComercial(
            {
                token: tokenn
            }
        ),
        {
            enabled: true
        });
    useEffect(() => {
        if (dataComercial?.data) {
            if (dataComercial.data === null)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataComercial.errorId });
            else {
                setListaClasificacionComercial(dataComercial.data);
            }
        }
    }, [dataComercial]);



    let { data: dataSubComercial } = useQuery([KeyNames.SessionRespuesta, {
        token: tokenn, type: 'subC'
    }],
        async () => await Api.ClasificacionSubComercial(
            {
                token: tokenn
            }
        ),
        {
            enabled: true
        });
    useEffect(() => {
        if (dataSubComercial?.data) {
            if (dataSubComercial.data === null)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataSubComercial.errorId });
            else {
                setListaClasificacionSubComercial(dataSubComercial.data);
            }
        }
    }, [dataSubComercial]);

    let { data: dataCategorias } = useQuery([KeyNames.SessionRespuesta, {
        token: tokenn, type: 'categ'
    }],
        async () => await Api.MapaCalorAllIn_CategoryList(
            {
                type: 'list',
                token: tokenn
            }
        ),
        {
            enabled: true
        });
    useEffect(() => {
        if (dataCategorias?.data) {
            if (dataCategorias.data === null)
                setFeedbackContext({ ...feedbackContext, showError: true, idError: dataCategorias.errorId });
            else {
                setListaCategoria(dataCategorias.data);
            }
        }
    }, [dataCategorias]);


    const [viewCierreVentas, setViewCierreVentas] = useState(false);


    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.LOCATARIOS]} >
                {!viewCierreVentas ?
                    <>
                        <PageTitle>
                            {title}

                        </PageTitle>
                        <div className="card">
                            <div className="card-header border-0 pt-6">
                                <div className="d-flex align-items-center mb-3">
                                    <div className="p-2" style={{ minWidth: "200px" }}>
                                        <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                                        <Select
                                            classNamePrefix='filter'
                                            components={animatedComponents}
                                            defaultValue={unidadEco ? getOptionValue(unidadEco.value) : getOptionValue(unidadesEconomicasList.defaultId)}
                                            isMulti={false}
                                            closeMenuOnSelect={true}
                                            options={unidadesEconomicasList.list}
                                            onChange={(uniEco) => setUnidadEconomica(uniEco)}
                                        />
                                    </div>
                                </div>

                            </div>

                            {abirGuardarContrato &&
                                <GestionLocatario unidadEconomicaId={unidadEconomica.value} listaClasificacionComercial={listaClasificacionComercial} listaClasificacionSubComercial={listaClasificacionSubComercial} listaCategoria={listaCategoria} contrato={contratoCurrentEdit} setSmShow={onAfterGuardar}></GestionLocatario>
                            }

                            <div className="card-body tab-content pt-0">
                                <AgTable
                                    idContent={"Tabla_Locatarios_" + unidadEconomica.value}
                                    apiService={Api.ListaLocatarios}
                                    setAuxData={null}
                                    header={header}
                                    titleExcel={"Locatarios - " + unidadEconomica.label}
                                    conditions={true}
                                    args={{ unidadEconomicaId: unidadEconomica.value, token: tokenn }}
                                    hideFilter={false}
                                    paginationPageSize={8}
                                    rowHeight={40}
                                    useFlex={false}
                                />
                            </div>

                        </div>


                        <Modal
                            size="sm"
                            show={guardadoExitoso}
                            onHide={() => setGuardadoExitoso(false)}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Header>
                                <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                                    Guardado Exitoso
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Footer style={{ margin: 'auto' }}>
                                <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                                    Aceptar
                                </button>
                            </Modal.Footer>
                        </Modal>
                    </> :
                    <>
                        <ConsultarCierreVentas setViewCierreVentas={setViewCierreVentas} title={"Consultar Cierre de Ventas"} unidadEconomica={unidadEconomica} nombreLocatario={contratoCurrentEdit?.nombre} numContrato={contratoCurrentEdit?.numContrato}></ConsultarCierreVentas>
                    </>
                }
            </PermissionsGate>
        </>
    )
}

export default Locatarios